import { IconChevronDown } from '@tabler/icons-react'
import { kebabCase } from 'lodash'
import type { OpenAPIV3_1 as OpenApi3 } from 'openapi-types'
import ReactMarkdown from 'react-markdown'

import { ButtonSolid } from 'components/Buttons'
import { components } from 'components/DefaultMdxComponents'
import { Heading } from 'components/Heading'

import { Schema } from '../Schema'
import { Content } from './Content'
import { Header } from './Header'
import { Label } from './Label'

type Props = {
	title: string
	description?: string
	definitions: Array<string>
	apiDocument: OpenApi3.Document
	isOpen: boolean

	onSetIsOpen: (isOpen: boolean) => void
}

export const Models = ({ title, description, definitions, apiDocument, isOpen = false, onSetIsOpen }: Props) => (
	<>
		<Header id={kebabCase(title)}>
			<Content>
				<div>
					<Heading level={1}>{title}</Heading>
					{description && <ReactMarkdown components={components}>{description}</ReactMarkdown>}
				</div>
			</Content>
			{!isOpen && (
				<ButtonSolid
					label={
						<Label>
							SHOW
							<IconChevronDown />
						</Label>
					}
					onClick={() => onSetIsOpen(true)}
				/>
			)}
		</Header>
		<div>
			{isOpen &&
				definitions.map((name) => {
					if (!apiDocument.components?.schemas?.[name])
						throw new Error(`Could not find the schema "${name}" in the spec.`)

					return (
						<Schema
							key={name}
							title={name}
							data={{ schema: { $ref: `#/components/schemas/${name}` } }}
							definitions={apiDocument.components?.schemas}
							linkPrefix={title ?? 'models'}
						/>
					)
				})}
		</div>
	</>
)
